// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Drawer mode styles ── */
.cpd-drawer {
  width: 100% !important;
}

@media (min-width: 768px) {
  .cpd-drawer {
    width: 480px !important;
  }
}

.cpd-input-row {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  margin-bottom: 4px !important;
}

.cpd-code-input {
  box-sizing: border-box !important;
  flex: 1 !important;
  display: flex !important;
  height: 40px !important;
  width: 100% !important;
  border-radius: 15px;
  border: 1px solid #cbd5e1 !important;
  background-color: transparent !important;
  padding: 4px 16px !important;
  font-size: 14px !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s, box-shadow 0.2s !important;
  outline: none !important;
  color: #0f172a !important;
}

.cpd-code-input:focus,
.cpd-code-input:focus-visible {
  outline: none !important;
  border-color: #0f172a !important;
  box-shadow: 0 0 0 1px #0f172a !important;
}

.cpd-code-input::placeholder {
  color: #64748b !important;
}

.cpd-apply-btn {
  box-sizing: border-box !important;
  height: 40px !important;
  padding: 8px 20px !important;
  background-color: #0860e6 !important;
  color: #fff !important;
  border: 1px solid #0860e6 !important;
  border-radius: 15px;
  font-size: 14px !important;
  font-weight: 500 !important;
  cursor: pointer !important;
  white-space: nowrap !important;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  min-width: 60px !important;
}

.cpd-apply-btn:hover {
  background-color: #0550c0 !important;
  border-color: #0550c0 !important;
}

.cpd-apply-btn:focus,
.cpd-apply-btn:focus-visible {
  outline: none !important;
  box-shadow: 0 0 0 1px #0f172a !important;
}

.cpd-apply-btn:disabled {
  pointer-events: none !important;
  opacity: 0.5 !important;
  background-color: #e2e8f0 !important;
  color: #64748b !important;
  border-color: #e2e8f0 !important;
}

/* ── Coupon ticket card ── */
.cpd-coupon-row {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px dashed rgba(42, 113, 255, 0.3);
  border-radius: 8px;
  background: transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.cpd-coupon-row:hover {
  background: rgba(42, 113, 255, 0.08);
}

.cpd-coupon-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}

.cpd-coupon-name {
  font-size: 14px;
  font-weight: 600;
  color: rgba(42, 113, 255, 0.85);
}

.cpd-coupon-desc {
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

.cpd-coupon-action {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.cpd-apply-pill {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-weight: 500;
  transition: background-color 0.15s, border-color 0.15s;
  border: 1px solid rgba(42, 113, 255, 0.4);
  border-radius: 14px;
  font-size: 12px;
  height: 32px;
  min-height: 32px;
  background-color: #2A71FF;
  padding: 0 16px;
  color: #fff;
  cursor: pointer;
}

.cpd-apply-pill:hover {
  background-color: #1f63ea;
}

.cpd-remove-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-weight: 500;
  transition: background-color 0.15s, border-color 0.15s;
  border: 1px solid #dc2626;
  border-radius: 6px;
  font-size: 12px;
  height: 32px;
  min-height: 32px;
  background-color: transparent;
  padding: 0 16px;
  color: #dc2626;
  cursor: pointer;
}

.cpd-remove-btn:hover {
  background-color: #fee2e2;
}

/* ── Legacy modal styles (unchanged) ── */
.coupon-inner-modal-single-box-rest {
  display: flex;
  align-items: center;
  padding: 5px;
  gap: 5px;
  margin-bottom: 10px;
  /* border: 1px solid lightgray; */
  border-radius: 7px;
  background-color: #f5f5f5;
}

.button-33-rest {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: white;
  color: #0860e6;
  font-weight: bold;
  font-size: 16px;
  border: 2px solid #0860e6;
  cursor: pointer;
}

.button-33-rest:hover {
  background-color: #0860e6;
  color: white;
}

.button-33-rest-red {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: white;
  color: red;
  font-weight: bold;
  font-size: 16px;
  border: 2px solid red;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.button-33-rest-red:hover {
  background-color: red;
  color: white;
}

.button-33:disabled,
.button-33-rest:disabled {
  pointer-events: none;
  opacity: 0.5;
  background-color: #e2e8f0 !important;
  color: #64748b !important;
  border-color: #e2e8f0 !important;
}

/* ── Coupon drawer header & wrapper overrides ── */
.cpd-drawer {
  box-shadow: 0 32px 90px rgba(15, 23, 42, 0.22) !important;
  border-left: 1px solid #cbd5e1 !important;
}

.cpd-drawer-header {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 16px 20px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  background: linear-gradient(135deg, rgba(255, 251, 235, 0.96), rgba(255, 255, 255, 0.92)) !important;
  flex-shrink: 0 !important;
}

.cpd-drawer-title-wrapper {
  display: flex !important;
  flex: 1 !important;
  align-items: center !important;
  gap: 16px !important;
}

.cpd-drawer-title {
  font-size: 20px !important;
  font-weight: 700 !important;
  letter-spacing: -0.025em !important;
  color: #0f172a !important;
  margin: 0 !important;
}

.cpd-drawer-close-wrapper {
  display: flex !important;
  align-items: center !important;
  gap: 16px !important;
}

.cpd-close-btn {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  white-space: nowrap !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  transition: background-color 0.15s, border-color 0.15s, color 0.15s !important;
  outline: none !important;
  border: 1px solid transparent !important;
  /* Retain existing height & width of the close button */
  width: 28px !important;
  height: 28px !important;
  border-radius: 9999px !important;
  background: transparent !important;
  cursor: pointer !important;
  padding: 0 !important;
}

.cpd-close-btn:hover {
  background-color: #f1f5f9 !important;
}

.cpd-close-btn svg {
  width: 16px !important;
  height: 16px !important;
  color: #64748b !important;
  pointer-events: none !important;
  flex-shrink: 0 !important;
}
/* ═══ DARK THEME — paymentCouponModal ═══ */
.dark .cpd-drawer {
  background-color: #1e293b !important;
  border-left-color: #334155 !important;
}
.dark .cpd-drawer-header {
  background: linear-gradient(135deg, rgba(30,41,59,0.97), rgba(15,23,42,0.97)) !important;
  border-bottom-color: #334155 !important;
}
.dark .cpd-drawer-title { color: #f1f5f9 !important; }
.dark .cpd-close-btn:hover { background-color: #334155 !important; }

.dark .cpd-code-input {
  border-color: #334155 !important;
  color: #f1f5f9 !important;
  background-color: #0f172a !important;
}
.dark .cpd-code-input::placeholder { color: #475569 !important; }
.dark .cpd-code-input:focus { border-color: #475569 !important; box-shadow: 0 0 0 1px #475569 !important; }

.dark .cpd-coupon-row { border-color: rgba(42,113,255,0.25); }
.dark .cpd-coupon-row:hover { background: rgba(42,113,255,0.07); }
.dark .cpd-coupon-desc { color: #94a3b8; }

.dark .coupon-inner-modal-single-box-rest {
  background-color: #1e293b;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/paymentCouponModal/paymentCouponModal.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,oCAAoC;EACpC,wCAAwC;EACxC,4BAA4B;EAC5B,0BAA0B;EAC1B,sDAAsD;EACtD,4FAA4F;EAC5F,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;EACxB,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,4BAA4B;EAC5B,oCAAoC;EACpC,sBAAsB;EACtB,oCAAoC;EACpC,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;EAC9B,2EAA2E;EAC3E,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,8DAA8D;AAChE;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,sDAAsD;EACtD,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,sDAAsD;EACtD,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;;EAEE,oBAAoB;EACpB,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,mDAAmD;AACnD;EACE,yDAAyD;EACzD,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,6BAA6B;EAC7B,2CAA2C;EAC3C,oGAAoG;EACpG,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,8EAA8E;EAC9E,wBAAwB;EACxB,wCAAwC;EACxC,uDAAuD;EACvD,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;EAChC,kCAAkC;EAClC,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;AACA,4CAA4C;AAC5C;EACE,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,wFAAwF;EACxF,uCAAuC;AACzC;AACA,0BAA0B,yBAAyB,EAAE;AACrD,6BAA6B,oCAAoC,EAAE;;AAEnE;EACE,gCAAgC;EAChC,yBAAyB;EACzB,oCAAoC;AACtC;AACA,qCAAqC,yBAAyB,EAAE;AAChE,8BAA8B,gCAAgC,EAAE,wCAAwC,EAAE;;AAE1G,wBAAwB,mCAAmC,EAAE;AAC7D,8BAA8B,iCAAiC,EAAE;AACjE,yBAAyB,cAAc,EAAE;;AAEzC;EACE,yBAAyB;AAC3B","sourcesContent":["/* ── Drawer mode styles ── */\n.cpd-drawer {\n  width: 100% !important;\n}\n\n@media (min-width: 768px) {\n  .cpd-drawer {\n    width: 480px !important;\n  }\n}\n\n.cpd-input-row {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  margin-bottom: 4px !important;\n}\n\n.cpd-code-input {\n  box-sizing: border-box !important;\n  flex: 1 !important;\n  display: flex !important;\n  height: 40px !important;\n  width: 100% !important;\n  border-radius: 15px;\n  border: 1px solid #cbd5e1 !important;\n  background-color: transparent !important;\n  padding: 4px 16px !important;\n  font-size: 14px !important;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;\n  transition: background-color 0.2s, border-color 0.2s, color 0.2s, box-shadow 0.2s !important;\n  outline: none !important;\n  color: #0f172a !important;\n}\n\n.cpd-code-input:focus,\n.cpd-code-input:focus-visible {\n  outline: none !important;\n  border-color: #0f172a !important;\n  box-shadow: 0 0 0 1px #0f172a !important;\n}\n\n.cpd-code-input::placeholder {\n  color: #64748b !important;\n}\n\n.cpd-apply-btn {\n  box-sizing: border-box !important;\n  height: 40px !important;\n  padding: 8px 20px !important;\n  background-color: #0860e6 !important;\n  color: #fff !important;\n  border: 1px solid #0860e6 !important;\n  border-radius: 15px;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  cursor: pointer !important;\n  white-space: nowrap !important;\n  transition: background-color 0.2s, border-color 0.2s, color 0.2s !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n  min-width: 60px !important;\n}\n\n.cpd-apply-btn:hover {\n  background-color: #0550c0 !important;\n  border-color: #0550c0 !important;\n}\n\n.cpd-apply-btn:focus,\n.cpd-apply-btn:focus-visible {\n  outline: none !important;\n  box-shadow: 0 0 0 1px #0f172a !important;\n}\n\n.cpd-apply-btn:disabled {\n  pointer-events: none !important;\n  opacity: 0.5 !important;\n  background-color: #e2e8f0 !important;\n  color: #64748b !important;\n  border-color: #e2e8f0 !important;\n}\n\n/* ── Coupon ticket card ── */\n.cpd-coupon-row {\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px;\n  margin-bottom: 12px;\n  border: 1px dashed rgba(42, 113, 255, 0.3);\n  border-radius: 8px;\n  background: transparent;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.cpd-coupon-row:hover {\n  background: rgba(42, 113, 255, 0.08);\n}\n\n.cpd-coupon-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n}\n\n.cpd-coupon-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: rgba(42, 113, 255, 0.85);\n}\n\n.cpd-coupon-desc {\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n.cpd-coupon-action {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n}\n\n.cpd-apply-pill {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-weight: 500;\n  transition: background-color 0.15s, border-color 0.15s;\n  border: 1px solid rgba(42, 113, 255, 0.4);\n  border-radius: 14px;\n  font-size: 12px;\n  height: 32px;\n  min-height: 32px;\n  background-color: #2A71FF;\n  padding: 0 16px;\n  color: #fff;\n  cursor: pointer;\n}\n\n.cpd-apply-pill:hover {\n  background-color: #1f63ea;\n}\n\n.cpd-remove-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-weight: 500;\n  transition: background-color 0.15s, border-color 0.15s;\n  border: 1px solid #dc2626;\n  border-radius: 6px;\n  font-size: 12px;\n  height: 32px;\n  min-height: 32px;\n  background-color: transparent;\n  padding: 0 16px;\n  color: #dc2626;\n  cursor: pointer;\n}\n\n.cpd-remove-btn:hover {\n  background-color: #fee2e2;\n}\n\n/* ── Legacy modal styles (unchanged) ── */\n.coupon-inner-modal-single-box-rest {\n  display: flex;\n  align-items: center;\n  padding: 5px;\n  gap: 5px;\n  margin-bottom: 10px;\n  /* border: 1px solid lightgray; */\n  border-radius: 7px;\n  background-color: #f5f5f5;\n}\n\n.button-33-rest {\n  width: 100%;\n  height: 40px;\n  border-radius: 5px;\n  background-color: white;\n  color: #0860e6;\n  font-weight: bold;\n  font-size: 16px;\n  border: 2px solid #0860e6;\n  cursor: pointer;\n}\n\n.button-33-rest:hover {\n  background-color: #0860e6;\n  color: white;\n}\n\n.button-33-rest-red {\n  width: 100%;\n  height: 40px;\n  border-radius: 5px;\n  background-color: white;\n  color: red;\n  font-weight: bold;\n  font-size: 16px;\n  border: 2px solid red;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n.button-33-rest-red:hover {\n  background-color: red;\n  color: white;\n}\n\n.button-33:disabled,\n.button-33-rest:disabled {\n  pointer-events: none;\n  opacity: 0.5;\n  background-color: #e2e8f0 !important;\n  color: #64748b !important;\n  border-color: #e2e8f0 !important;\n}\n\n/* ── Coupon drawer header & wrapper overrides ── */\n.cpd-drawer {\n  box-shadow: 0 32px 90px rgba(15, 23, 42, 0.22) !important;\n  border-left: 1px solid #cbd5e1 !important;\n}\n\n.cpd-drawer-header {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  padding: 16px 20px !important;\n  border-bottom: 1px solid #f1f5f9 !important;\n  background: linear-gradient(135deg, rgba(255, 251, 235, 0.96), rgba(255, 255, 255, 0.92)) !important;\n  flex-shrink: 0 !important;\n}\n\n.cpd-drawer-title-wrapper {\n  display: flex !important;\n  flex: 1 !important;\n  align-items: center !important;\n  gap: 16px !important;\n}\n\n.cpd-drawer-title {\n  font-size: 20px !important;\n  font-weight: 700 !important;\n  letter-spacing: -0.025em !important;\n  color: #0f172a !important;\n  margin: 0 !important;\n}\n\n.cpd-drawer-close-wrapper {\n  display: flex !important;\n  align-items: center !important;\n  gap: 16px !important;\n}\n\n.cpd-close-btn {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n  white-space: nowrap !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  transition: background-color 0.15s, border-color 0.15s, color 0.15s !important;\n  outline: none !important;\n  border: 1px solid transparent !important;\n  /* Retain existing height & width of the close button */\n  width: 28px !important;\n  height: 28px !important;\n  border-radius: 9999px !important;\n  background: transparent !important;\n  cursor: pointer !important;\n  padding: 0 !important;\n}\n\n.cpd-close-btn:hover {\n  background-color: #f1f5f9 !important;\n}\n\n.cpd-close-btn svg {\n  width: 16px !important;\n  height: 16px !important;\n  color: #64748b !important;\n  pointer-events: none !important;\n  flex-shrink: 0 !important;\n}\n/* ═══ DARK THEME — paymentCouponModal ═══ */\n.dark .cpd-drawer {\n  background-color: #1e293b !important;\n  border-left-color: #334155 !important;\n}\n.dark .cpd-drawer-header {\n  background: linear-gradient(135deg, rgba(30,41,59,0.97), rgba(15,23,42,0.97)) !important;\n  border-bottom-color: #334155 !important;\n}\n.dark .cpd-drawer-title { color: #f1f5f9 !important; }\n.dark .cpd-close-btn:hover { background-color: #334155 !important; }\n\n.dark .cpd-code-input {\n  border-color: #334155 !important;\n  color: #f1f5f9 !important;\n  background-color: #0f172a !important;\n}\n.dark .cpd-code-input::placeholder { color: #475569 !important; }\n.dark .cpd-code-input:focus { border-color: #475569 !important; box-shadow: 0 0 0 1px #475569 !important; }\n\n.dark .cpd-coupon-row { border-color: rgba(42,113,255,0.25); }\n.dark .cpd-coupon-row:hover { background: rgba(42,113,255,0.07); }\n.dark .cpd-coupon-desc { color: #94a3b8; }\n\n.dark .coupon-inner-modal-single-box-rest {\n  background-color: #1e293b;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
